var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.5H2C1.59 22.5 1.25 22.16 1.25 21.75C1.25 21.34 1.59 21 2 21H22C22.41 21 22.75 21.34 22.75 21.75C22.75 22.16 22.41 22.5 22 22.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.5V22.5H14.25V4.5C14.25 3.4 13.8 2.5 12.45 2.5H11.55C10.2 2.5 9.75 3.4 9.75 4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5V22.5H7V10.5C7 9.4 6.6 8.5 5.4 8.5H4.6C3.4 8.5 3 9.4 3 10.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5V22.5H21V15.5C21 14.4 20.6 13.5 19.4 13.5H18.6C17.4 13.5 17 14.4 17 15.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBold);
export default __webpack_public_path__ + "static/media/chart-bold.5d3d7ca7402f3f3c2bed7b868c818efa.svg";
export { ForwardRef as ReactComponent };